import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

import { SpinnerService } from '../spinner/spinner.service';
import { CookieService } from 'ngx-cookie';
import { ParametroCarga } from '../../models/spinner/parametroCarga.class';
import { Configuracion } from '../../contants/configuracion.constant';
import { Router } from '@angular/router';
import { MenuService } from '../menu/menu.service';

@Injectable()
export class InterceptorHttpService implements HttpInterceptor {

  contador = 0;


  constructor(private spinnerService: SpinnerService, private cookieService: CookieService, private router: Router, private menuService :MenuService) { }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.contador++;
    if (this.contador > 0) { this.spinnerService.status.next(new ParametroCarga( request.headers.get(Configuracion.HEADER_DESCRIPCION_PETICION), true)); }
    return next.handle(request).do((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        this.cerrarSpinner();
      }
    }, (err: HttpErrorResponse) => {
      if (err instanceof HttpErrorResponse) {
        this.cerrarSpinner();
        if (err.status === 401) {
          this.cookieService.removeAll();

          window.location.replace(Configuracion.URL_SSO_HOME);
          /*this.menuService.redireccionarLogin().then((response) => {
            document.write(response);
            });*/

        }  else if (err.status === 403) {
          this.cookieService.removeAll();
          this.router.navigate(["/", "forbidden-page"]);
        }
      }
    });
  }

  async cerrarSpinner() {
    setTimeout(() => {
      this.contador--;
      if (this.contador === 0) { this.spinnerService.status.next(new ParametroCarga('', false)); }
    }, 500);
  }



}



// WEBPACK FOOTER //
// ./src/app/services/interceptor/interceptor-http.service.ts